<template>
	<div class="ui large modal" id="videoHelpPopUp" ref="modal">
		<div class="close">
			<i class="window close icon"></i>
		</div>
		<div class="content">
			<div class="frame">
				<iframe src="https://podpora.rokus.com/datoteke/mauthor/008/"></iframe>
			</div>
		</div>
	</div>
</template>

<script>
	import popup from './Popup.vue'

    export default {
    	mixins: [popup],
    	data() {
    		return {
    		}
    	},
    	mounted() {
    		
    	}
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/modals/ActivationCodeHelp.vue